import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d47f3ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Wachtwoord vergeten", -1))
const _hoisted_2 = { class: "controlrow edit" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottombar",
  style: {"text-align":"right","right":"8px"}
}, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "button lightfill"
  }, "Verzenden")
], -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalMessage = _resolveComponent("ModalMessage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      class: "mrbox round border lightfill",
      style: {"height":"120px","max-width":"400px"},
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitForm && $setup.submitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "gebruikersnaam",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.gebruikersnaam) = $event)),
            placeholder: "gebruikersnaam"
          }, null, 512), [
            [_vModelText, $setup.gebruikersnaam]
          ])
        ]),
        _hoisted_3
      ])
    ], 32),
    ($setup.modal?.show)
      ? (_openBlock(), _createBlock(_component_ModalMessage, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.modal.show = false))
        }, {
          header: _withCtx(() => [
            _createElementVNode("h1", null, _toDisplayString($setup.modal.title), 1)
          ]),
          body: _withCtx(() => [
            _createElementVNode("p", {
              innerHTML: $setup.modal.msg
            }, null, 8, _hoisted_5)
          ]),
          default: _withCtx(() => [
            _createElementVNode("h1", null, _toDisplayString($setup.modal.title), 1),
            _createElementVNode("p", {
              innerHTML: $setup.modal.msg
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}